var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show(),
          expression: "show()",
        },
      ],
      key: _vm.messageId + "-" + _vm.tick,
      staticClass: "idle-indicator w-100",
    },
    [
      _c("a-divider", { staticClass: "idle" }, [_vm._v(_vm._s(_vm.time()))]),
      _vm._v(" "),
      _vm.tookTimeInSeconds() < 60
        ? _c("span", { staticClass: "idle-desc" }, [
            _vm._v("Chat is idle due to 1 minutes inactivity"),
          ])
        : _c("span", { staticClass: "idle-desc" }, [
            _vm._v(
              "Chat is idle due to " +
                _vm._s(_vm.tookTimeInMinutes()) +
                " minutes inactivity"
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }